/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import history from '../../history';

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

class Link extends React.Component {
  static contextTypes = {
    path: PropTypes.string.isRequired,
  };

  static propTypes = {
    to: PropTypes.string,
    children: PropTypes.node,
    onClick: PropTypes.func,
    activeClassName: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    onClick: null,
    activeClassName: null,
    className: null,
    to: null,
    children: null,
  };

  handleClick = event => {
    if (this.props.onClick) {
      this.props.onClick(event);
    }

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
      return;
    }

    if (event.defaultPrevented === true) {
      return;
    }

    event.preventDefault();
    if (this.props.to) {
      if (this.props.to.startsWith('http')) {
        window.location.href = this.props.to;
      } else {
        history.push(this.props.to);
      }
    }
  };

  render() {
    const { to, children, activeClassName, className, ...props } = this.props;
    let modifiedClassName = className || '';
    if (activeClassName && to === this.context.path) {
      modifiedClassName += ` ${activeClassName}`;
    }
    return (
      <a
        href={to}
        {...props}
        onClick={this.handleClick}
        className={modifiedClassName}
      >
        {children}
      </a>
    );
  }
}

export default Link;



// WEBPACK FOOTER //
// ./src/components/Link/Link.js